<ng-container *ngIf="node$ | async as node">
  <div class="navigation__overflow">
    <ul
      class="nav__links nav__links--products gridMenu secondaryBackground thirdBar"
      style="font-size: 18px; margin-bottom: 0"
    >
      <li
        class="dropdown-container auto nav__links--primary nav__links--primary-has__sub"
        *ngFor="let child of node.children; let i = index"
        (mouseenter)="hoveredIndex = i"
        (mouseleave)="hoveredIndex = null"
      >
        <span class="nav__link mt-3 navBarMenuTitle under">
          <a [routerLink]="child.url" [title]="child.title" (click)="setPreviousQuery(child.url)">
            {{ child.title }}
          </a>
        </span>
        <div style="height: 20px;"></div>
        <div class="sub__navigation col-md-3 col-lg-2" [class.show-sub]="hoveredIndex === i">
          <div class="row">
            <div class="sub-navigation-section col-md-12">
              <ul class="sub-navigation-list">
                <li class="nav__link--secondary" *ngFor="let grandchild of child.children">
                  <a [routerLink]="grandchild.url" [title]="grandchild.title" (click)="setPreviousQuery(grandchild.url)">{{ grandchild.title }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</ng-container>
